export const CANONICAL_COMPONENT_GROUPS = [
  {
    titleKey: 'BRAND_KIT.INVENTORY.FORMS',
    components: [
      {
        name: 'Input',
        path: 'app/javascript/dashboard/components-next/input/Input.vue',
      },
      {
        name: 'TextArea',
        path: 'app/javascript/dashboard/components-next/textarea/TextArea.vue',
      },
      {
        name: 'InlineInput',
        path: 'app/javascript/dashboard/components-next/inline-input/InlineInput.vue',
      },
      {
        name: 'DurationInput',
        path: 'app/javascript/dashboard/components-next/input/DurationInput.vue',
      },
      {
        name: 'PhoneNumberInput',
        path: 'app/javascript/dashboard/components-next/phonenumberinput/PhoneNumberInput.vue',
      },
      {
        name: 'TagInput',
        path: 'app/javascript/dashboard/components-next/taginput/TagInput.vue',
      },
      {
        name: 'Checkbox',
        path: 'app/javascript/dashboard/components-next/checkbox/Checkbox.vue',
      },
      {
        name: 'Switch',
        path: 'app/javascript/dashboard/components-next/switch/Switch.vue',
      },
      {
        name: 'RadioCard',
        path: 'app/javascript/dashboard/components-next/radioCard/RadioCard.vue',
      },
      {
        name: 'ChoiceToggle',
        path: 'app/javascript/dashboard/components-next/input/ChoiceToggle.vue',
      },
      {
        name: 'ColorPicker',
        path: 'app/javascript/dashboard/components-next/colorpicker/ColorPicker.vue',
      },
      {
        name: 'Editor',
        path: 'app/javascript/dashboard/components-next/Editor/Editor.vue',
      },
      {
        name: 'DatePicker',
        path: 'app/javascript/dashboard/components/ui/DatePicker/DatePicker.vue',
      },
    ],
  },
  {
    titleKey: 'BRAND_KIT.INVENTORY.SELECTION',
    components: [
      {
        name: 'AdaptiveSelect',
        path: 'app/javascript/dashboard/components-next/adaptive-select/AdaptiveSelect.vue',
      },
    ],
  },
  {
    titleKey: 'BRAND_KIT.INVENTORY.ACTIONS',
    components: [
      {
        name: 'Button',
        path: 'app/javascript/dashboard/components-next/button/Button.vue',
      },
      {
        name: 'ConfirmButton',
        path: 'app/javascript/dashboard/components-next/button/ConfirmButton.vue',
      },
      {
        name: 'ButtonGroup',
        path: 'app/javascript/dashboard/components-next/buttonGroup/ButtonGroup.vue',
      },
      {
        name: 'DropdownMenu',
        path: 'app/javascript/dashboard/components-next/dropdown-menu/DropdownMenu.vue',
      },
      {
        name: 'Dialog',
        path: 'app/javascript/dashboard/components-next/dialog/Dialog.vue',
      },
      {
        name: 'Popover',
        path: 'app/javascript/dashboard/components-next/popover/Popover.vue',
      },
      {
        name: 'TabBar',
        path: 'app/javascript/dashboard/components-next/tabbar/TabBar.vue',
      },
      {
        name: 'Breadcrumb',
        path: 'app/javascript/dashboard/components-next/breadcrumb/Breadcrumb.vue',
      },
      {
        name: 'Accordion',
        path: 'app/javascript/dashboard/components-next/Accordion/Accordion.vue',
      },
    ],
  },
  {
    titleKey: 'BRAND_KIT.INVENTORY.DATA',
    components: [
      {
        name: 'BaseTable',
        path: 'app/javascript/dashboard/components-next/table/BaseTable.vue',
      },
      {
        name: 'BaseTableRow',
        path: 'app/javascript/dashboard/components-next/table/BaseTableRow.vue',
      },
      {
        name: 'BaseTableCell',
        path: 'app/javascript/dashboard/components-next/table/BaseTableCell.vue',
      },
      {
        name: 'PaginationFooter',
        path: 'app/javascript/dashboard/components-next/pagination/PaginationFooter.vue',
      },
      {
        name: 'TanStackTable',
        path: 'app/javascript/dashboard/components/table/Table.vue',
      },
      {
        name: 'TanStackPagination',
        path: 'app/javascript/dashboard/components/table/Pagination.vue',
      },
      {
        name: 'Spinner',
        path: 'app/javascript/dashboard/components-next/spinner/Spinner.vue',
      },
      {
        name: 'Banner',
        path: 'app/javascript/dashboard/components-next/banner/Banner.vue',
      },
      {
        name: 'Flag',
        path: 'app/javascript/dashboard/components-next/flag/Flag.vue',
      },
      {
        name: 'Avatar',
        path: 'app/javascript/dashboard/components-next/avatar/Avatar.vue',
      },
      {
        name: 'Label',
        path: 'app/javascript/dashboard/components-next/label/Label.vue',
      },
      {
        name: 'Icon',
        path: 'app/javascript/dashboard/components-next/icon/Icon.vue',
      },
    ],
  },
  {
    titleKey: 'BRAND_KIT.INVENTORY.LAYOUT',
    components: [
      {
        name: 'PageContentLayout',
        path: 'app/javascript/dashboard/components-next/layout/PageContentLayout.vue',
      },
      {
        name: 'ModuleSettingsLayout',
        path: 'app/javascript/dashboard/components-next/layout/ModuleSettingsLayout.vue',
      },
      {
        name: 'SettingsListGroup',
        path: 'app/javascript/dashboard/components-next/layout/SettingsListGroup.vue',
      },
      {
        name: 'SettingsFieldSection',
        path: 'app/javascript/dashboard/components-next/Settings/SettingsFieldSection.vue',
      },
      {
        name: 'SettingsToggleSection',
        path: 'app/javascript/dashboard/components-next/Settings/SettingsToggleSection.vue',
      },
      {
        name: 'SettingsAccordion',
        path: 'app/javascript/dashboard/components-next/Settings/SettingsAccordion.vue',
      },
    ],
  },
  {
    titleKey: 'BRAND_KIT.INVENTORY.SUPER_ADMIN',
    components: [
      {
        name: 'form_text',
        path: 'app/views/super_admin/shared/_form_text.html.erb',
      },
      {
        name: 'form_textarea',
        path: 'app/views/super_admin/shared/_form_textarea.html.erb',
      },
      {
        name: 'form_select',
        path: 'app/views/super_admin/shared/_form_select.html.erb',
      },
      {
        name: 'form_checkbox',
        path: 'app/views/super_admin/shared/_form_checkbox.html.erb',
      },
      {
        name: 'form_file',
        path: 'app/views/super_admin/shared/_form_file.html.erb',
      },
      {
        name: 'form_image',
        path: 'app/views/super_admin/shared/_form_image.html.erb',
      },
      {
        name: 'collection',
        path: 'app/views/super_admin/application/_collection.html.erb',
      },
      {
        name: 'delete_modal',
        path: 'app/views/super_admin/shared/_delete_modal.html.erb',
      },
    ],
  },
];
